export default __webpack_public_path__ + "static/media/info.3f4e8237.svg";